import makeCriteriaProvider from './makeCriteriaProvider';
import DateRangeFacetDetails from './MonthFacetDetails';
import { monthTag } from './tag';

export default {
  tag: monthTag,
  makeCriteriaProvider,
  DetailsControl: DateRangeFacetDetails
};
